/**
 * Selector de idioma ES/EN con traducciones hardcodeadas.
 * Bandera ES = español, bandera US = inglés. Preferencia en localStorage (lang).
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'lang';
  var DEFAULT_LANG = 'es';
  var savedEs = {};
  var productTranslationsCache = null;
  var productOriginalContent = {};
  function getProductTranslationsUrl() {
    return window.PRODUCT_TRANSLATIONS_ASSET_URL || (window.Shopify?.routes?.root || '/') + 'cdn/shop/t/' + 'product-translations.json';
  }

  function formatTodayDate(lang) {
    var d = new Date();
    if (lang === 'es') {
      return d.toLocaleDateString('es-ES', { day: 'numeric', month: 'long' });
    }
    var month = d.toLocaleDateString('en-US', { month: 'long' });
    var day = d.getDate();
    var v = day % 100;
    var ord = (v >= 11 && v <= 13) ? 'th' : (['th', 'st', 'nd', 'rd'][day % 10] || 'th');
    return month + ' ' + day + ord;
  }

  function injectTodayDateToken(html, lang, handle) {
    if (!html || html.indexOf('{{TODAY_DATE}}') === -1) return html;
    var today = formatTodayDate(lang);
    if (handle === 'pack-titulos-premiere-pro' || handle === 'pack-v2-titulos-premiere-pro' || handle === 'pack-titulos-after-effects' || handle === 'pack-v2-0-titulos-after-effects' || handle === 'davinci-resolve-v1' || handle === 'pack-titles-capcut') {
      today = '<span class="today-date-glow">' + today + '</span>';
    }
    return html.replace(/\{\{TODAY_DATE\}\}/g, today);
  }

  function wrapCapcutPriceGlow(priceHtml) {
    if (!priceHtml) return priceHtml;
    return '<span class="today-price-glow">' + priceHtml + '</span>';
  }

  function refreshCapcutOfferHighlights() {
    var lang = getLang();
    // Fecha "solo por hoy": localizar TODOS los .today-date-glow al idioma actual (no solo CapCut).
    document.querySelectorAll('.today-date-glow').forEach(function (el) {
      el.textContent = formatTodayDate(lang);
    });
    var container = document.querySelector('[data-product-handle="pack-titles-capcut"]');
    if (!container) return;
    var priceHtml = container.getAttribute('data-i18n-price-html') || '';
    if (!priceHtml) return;
    container.querySelectorAll('.today-price-glow').forEach(function (el) {
      el.innerHTML = priceHtml;
    });
  }

  var I18N = {
    /* ──────── Ultimate Bundle 2026 · PDP showcase (UBX) ──────── */
    ubx_manifesto_eyebrow: { es: 'Ultimate Bundle · Editors Exclusive 2026', en: 'Ultimate Bundle · Editors Exclusive 2026' },
    ubx_manifesto_title_1: { es: 'No es una lista suelta de archivos.', en: 'Not just a random list of files.' },
    ubx_manifesto_title_2: { es: 'Es tu nueva capacidad de editar', en: 'It is your new editing capability' },
    ubx_manifesto_lead:    { es: 'Un ecosistema unificado de assets, automatizaciones y presets diseñado para acelerar tus entregas, escalar tu calidad visual y mantener consistencia absoluta en cada proyecto.', en: 'A unified ecosystem of assets, automations and presets engineered to speed up delivery, scale visual quality and keep absolute consistency across every project.' },
    ubx_chip_download:     { es: 'Descarga instantánea', en: 'Instant download' },
    ubx_chip_updates:      { es: 'Actualizaciones de por vida', en: 'Lifetime updates' },
    ubx_arsenal_eyebrow:   { es: 'El arsenal completo', en: 'The full arsenal' },
    ubx_arsenal_title:     { es: '8 productos. Un solo pack.', en: '8 products. One single pack.' },
    ubx_stack_benefit_1_title: { es: '8 productos', en: '8 products' },
    ubx_stack_benefit_1_text:  { es: 'Un solo pack unificado', en: 'One unified pack' },
    ubx_stack_benefit_2_title: { es: 'Pack profesional', en: 'Professional pack' },
    ubx_stack_benefit_2_text:  { es: 'Plugins, presets y assets listos', en: 'Plugins, presets and assets ready to go' },
    ubx_stack_benefit_3_title: { es: 'Alto nivel', en: 'High level' },
    ubx_stack_benefit_3_text:  { es: 'Usado en producciones profesionales', en: 'Used in professional productions' },
    ubx_stack_benefit_4_title: { es: 'Para siempre', en: 'Forever' },
    ubx_stack_benefit_4_text:  { es: 'Actualizaciones incluidas', en: 'Updates included' },
    ubx_stack_pdp_description: { es: '8 productos en un solo pack para editores. Descargá, instalá y acelerá tu pipeline de principio a fin.', en: '8 products in one pack for editors. Download, install and speed up your pipeline end to end.' },

    ubx_pack_01_badge: { es: '2026 ULTIMATE EDITING PACK', en: '2026 ULTIMATE EDITING PACK' },
    ubx_pack_01_hook:  { es: 'Base de velocidad para tu pipeline.', en: 'The speed base for your pipeline.' },
    ubx_pack_02_badge: { es: 'PLUGIN ULTRAWORKFLOW', en: 'ULTRAWORKFLOW PLUGIN' },
    ubx_pack_02_hook:  { es: 'Performance + automatización 1-click.', en: 'Performance + 1-click automation.' },
    ubx_pack_03_badge: { es: 'ADVANCED PACK', en: 'ADVANCED PACK' },
    ubx_pack_03_hook:  { es: 'Composición compleja sin fricción.', en: 'Complex composition without friction.' },
    ubx_pack_04_badge: { es: 'VFX PACK PREMIERE PRO', en: 'VFX PACK PREMIERE PRO' },
    ubx_pack_04_hook:  { es: 'Impacto visual nativo en Premiere.', en: 'Native visual impact inside Premiere.' },
    ubx_pack_05_badge: { es: 'PROYECTO MIX MEDIA', en: 'MIXED MEDIA PROJECT' },
    ubx_pack_05_hook:  { es: 'Proyecto editable híbrido premium.', en: 'Editable premium hybrid project.' },
    ubx_pack_06_badge: { es: '+500 PLATINUM LUTS PACK', en: '+500 PLATINUM LUTS PACK' },
    ubx_pack_06_hook:  { es: 'Ciencia de color cinematográfica.', en: 'Cinematic color science.' },
    ubx_pack_07_badge: { es: 'TITLES PACK · AE + PR · V1 & V2', en: 'TITLES PACK · AE + PR · V1 & V2' },
    ubx_pack_07_hook:  { es: 'Tipografía dinámica, 4 variantes.', en: 'Dynamic typography, 4 variants.' },
    ubx_pack_08_badge: { es: '+5000 SFX PACK', en: '+5000 SFX PACK' },
    ubx_pack_08_hook:  { es: 'Diseño sonoro inmersivo en +80 carpetas.', en: 'Immersive sound design across +80 folders.' },

    ubx_matrix_eyebrow:    { es: 'Matriz de valor', en: 'Value matrix' },
    ubx_matrix_title:      { es: 'Comprar suelto cuesta más, con el bundle mucho menos.', en: 'Buying piece by piece costs more. With the bundle, much less.' },
    ubx_matrix_col_sep:    { es: 'Comprando por separado', en: 'Buying separately' },
    ubx_matrix_total_label:{ es: 'Total individual', en: 'Individual total' },
    ubx_matrix_bundle_tag: { es: 'Ultimate Bundle 2026', en: 'Ultimate Bundle 2026' },
    ubx_matrix_bundle_name:{ es: 'El stack unificado', en: 'The unified stack' },
    ubx_matrix_save_prefix:{ es: 'Ahorrás', en: 'You save' },
    ubx_matrix_cta:        { es: 'Quiero el bundle completo', en: 'I want the full bundle' },

    ubx_truth_eyebrow: { es: 'La verdad de quienes ya lo usan', en: 'The truth from editors already using it' },
    ubx_truth_title:   { es: '3843 reseñas verificadas · 4.9/5 estrellas', en: '3843 verified reviews · 4.9/5 stars' },

    ubx_quote_1_text:   { es: '“Entregué un proyecto completo en la mitad de tiempo. El sistema de timeline y presets me cambió la rutina.”', en: '“I delivered a full project in half the time. The timeline and presets system completely changed my routine.”' },
    ubx_quote_1_author: { es: 'Mateo R. · Editor freelance', en: 'Mateo R. · Freelance editor' },
    ubx_quote_2_text:   { es: '“Mi cliente aprobó el edit al primer corte. Nunca me había pasado.”', en: '“My client approved the edit on the first cut. Never happened before.”' },
    ubx_quote_2_author: { es: 'Lucía F. · Editora agencia', en: 'Lucía F. · Agency editor' },
    ubx_quote_3_text:   { es: '“Los LUTs y los SFX solos ya pagan el bundle. El resto es bonus directo.”', en: '“The LUTs and SFX alone are worth the bundle. Everything else is a direct bonus.”' },
    ubx_quote_3_author: { es: 'Tomás G. · Colorista', en: 'Tomás G. · Colorist' },
    ubx_quote_4_text:   { es: '“Dejé de pelear con el software. Ultraworkflow me devolvió horas reales cada semana.”', en: '“I stopped fighting the software. Ultraworkflow gave me real hours back every week.”' },
    ubx_quote_4_author: { es: 'Sofi M. · Motion designer', en: 'Sofi M. · Motion designer' },
    ubx_quote_5_text:   { es: '“Pasé de improvisar a tener un pipeline real. Otra liga.”', en: '“I went from improvising to having a real pipeline. Next level.”' },
    ubx_quote_5_author: { es: 'Bruno P. · Reels para artistas', en: 'Bruno P. · Reels for artists' },
    ubx_quote_6_text:   { es: '“Los Titles V2 son los mejores que probé. Punto.”', en: '“The V2 Titles are the best I have ever used. Period.”' },
    ubx_quote_6_author: { es: 'Cami D. · Editora YouTube', en: 'Cami D. · YouTube editor' },

    ubx_guarantee_title: { es: 'Garantía de optimización de flujo por 7 días.', en: '7-day workflow optimization guarantee.' },
    ubx_guarantee_text:  { es: 'Completamente sujeto a los', en: 'Completely subject to the' },

    ubx_sticky_name: { es: 'Ultimate Bundle 2026', en: 'Ultimate Bundle 2026' },
    ubx_sticky_cta:  { es: 'Agregar al carrito', en: 'Add to cart' },

    aio_manifesto_eyebrow: { es: 'All-in-One · Todos los productos', en: 'All-in-One · All Products' },
    aio_manifesto_title_1: { es: 'No compres uno a uno.', en: 'Do not buy one by one.' },
    aio_manifesto_title_2: { es: 'Llevate la tienda completa', en: 'Get the full store' },
    aio_chip_download: { es: 'Descarga instantánea', en: 'Instant download' },
    aio_chip_updates: { es: 'Actualizaciones de por vida', en: 'Lifetime updates' },
    aio_arsenal_eyebrow: { es: 'La tienda completa', en: 'The full store' },
    aio_arsenal_title: { es: ' productos. Una sola compra.', en: ' products. One single purchase.' },
    aio_matrix_eyebrow: { es: 'Matriz de valor', en: 'Value matrix' },
    aio_matrix_title: { es: 'Comprar suelto cuesta más. Con All-in-One, mucho menos.', en: 'Buying separately costs more. With All-in-One, much less.' },
    aio_matrix_col_sep: { es: 'Comprando por separado', en: 'Buying separately' },
    aio_matrix_total_label: { es: 'Total individual', en: 'Individual total' },
    aio_matrix_bundle_tag: { es: 'All-in-One', en: 'All-in-One' },
    aio_matrix_bundle_name: { es: 'Todos los productos de la tienda', en: 'Every product in the store' },
    aio_matrix_save_prefix: { es: 'Ahorrás', en: 'You save' },
    aio_matrix_cta: { es: 'Quiero todos los productos', en: 'I want all products' },
    aio_truth_eyebrow: { es: 'La verdad de quienes ya lo usan', en: 'The truth from editors already using it' },
    aio_truth_title: { es: '3843 reseñas verificadas · 4.9/5 estrellas', en: '3843 verified reviews · 4.9/5 stars' },
    aio_quote_1_text: { es: '"Compré el All-in-One y dejé de buscar assets sueltos. Tengo todo en un solo lugar."', en: '"I bought All-in-One and stopped hunting for loose assets. Everything in one place."' },
    aio_quote_1_author: { es: 'Diego L. · Editor freelance', en: 'Diego L. · Freelance editor' },
    aio_quote_2_text: { es: '"El Ultimate Bundle era bueno, pero el All-in-One tiene el doble de productos por casi lo mismo."', en: '"Ultimate Bundle was good, but All-in-One has twice the products for almost the same price."' },
    aio_quote_2_author: { es: 'Valentina S. · Editora agencia', en: 'Valentina S. · Agency editor' },
    aio_quote_3_text: { es: '"Los plugins extra y los proyectos editables solos valen la diferencia."', en: '"The extra plugins and editable projects alone are worth the difference."' },
    aio_quote_3_author: { es: 'Nico M. · Motion designer', en: 'Nico M. · Motion designer' },
    aio_quote_4_text: { es: '"Si vas a invertir una vez, que sea en la tienda completa. No te arrepentís."', en: '"If you invest once, make it the full store. No regrets."' },
    aio_quote_4_author: { es: 'Carla R. · Editora YouTube', en: 'Carla R. · YouTube editor' },
    aio_quote_5_text: { es: '"Silence Cutter y los títulos para DaVinci no están en ningún bundle. Solo acá."', en: '"Silence Cutter and DaVinci titles are not in any bundle. Only here."' },
    aio_quote_5_author: { es: 'Martín A. · Editor corporativo', en: 'Martín A. · Corporate editor' },
    aio_quote_6_text: { es: '"Compré productos sueltos antes y gasté el triple. All-in-One es obvio si editás seguido."', en: '"I bought individual products before and spent triple. All-in-One is a no-brainer if you edit often."' },
    aio_quote_6_author: { es: 'Paula V. · Editora Instagram', en: 'Paula V. · Instagram editor' },
    aio_quote_7_text: { es: '"Los shakes y el 3D title le dieron otro nivel a mis reels."', en: '"Shakes and the 3D title took my reels to another level."' },
    aio_quote_7_author: { es: 'Facundo H. · Creador de contenido', en: 'Facundo H. · Content creator' },
    aio_quote_8_text: { es: '"Descarga instantánea, todo organizado y actualizaciones incluidas. No pedís más."', en: '"Instant download, everything organized and updates included. Nothing else to ask for."' },
    aio_quote_8_author: { es: 'Ana K. · Editora freelance', en: 'Ana K. · Freelance editor' },
    aio_guarantee_title: { es: 'Garantía de optimización de flujo por 7 días.', en: '7-day workflow optimization guarantee.' },
    aio_guarantee_text: { es: 'Completamente sujeto a los', en: 'Completely subject to the' },
    aio_vs_ub_eyebrow: { es: 'Por qué elegir All-in-One', en: 'Why choose All-in-One' },
    aio_vs_ub_title: { es: 'Más productos. Mejor precio. Sin límites.', en: 'More products. Better price. No limits.' },
    aio_vs_ub_ub_badge: { es: 'Bundle parcial', en: 'Partial bundle' },
    aio_vs_ub_ub_name: { es: 'Ultimate Bundle 2026', en: 'Ultimate Bundle 2026' },
    aio_vs_ub_aio_badge: { es: 'Recomendado', en: 'Recommended' },
    aio_vs_ub_aio_name: { es: 'All-in-One · Todos los productos', en: 'All-in-One · All Products' },
    aio_vs_ub_products_label: { es: 'productos', en: 'products' },
    aio_vs_ub_row_core: { es: 'Pack 2026, VFX, LUTs, SFX y Titles', en: '2026 Pack, VFX, LUTs, SFX and Titles' },
    aio_vs_ub_row_ultra: { es: 'Plugin Ultraworkflow', en: 'Ultraworkflow Plugin' },
    aio_vs_ub_row_plugins: { es: 'Plugins extra (Silence Cutter, Shakes)', en: 'Extra plugins (Silence Cutter, Shakes)' },
    aio_vs_ub_row_editables: { es: 'Proyectos editables extra', en: 'Extra editable projects' },
    aio_vs_ub_row_davinci: { es: 'DaVinci Resolve Titles y 3D Title', en: 'DaVinci Resolve Titles and 3D Title' },
    aio_vs_ub_value_note: { es: 'Mejor valor por producto que el Ultimate Bundle', en: 'Better value per product than Ultimate Bundle' },
    aio_vs_ub_cta: { es: 'Quiero el All-in-One', en: 'I want All-in-One' },
    aio_vs_ub_see_ub: { es: 'Ver Ultimate Bundle', en: 'View Ultimate Bundle' },
    aio_vs_ub_extras_title: { es: 'Solo en All-in-One', en: 'Only in All-in-One' },
    aio_vs_ub_extras_count: { es: 'productos exclusivos vs Ultimate Bundle', en: 'exclusive products vs Ultimate Bundle' },

    efx_manifesto_eyebrow: { es: 'Pack de Efectos Esenciales', en: 'Essential Effects Pack' },
    efx_manifesto_title_1: { es: 'Tres pilares visuales.', en: 'Three visual pillars.' },
    efx_manifesto_title_2: { es: 'Shakes. VFX. Texto 3D.', en: 'Shakes. VFX. 3D Text.' },
    efx_chip_download: { es: 'Descarga instantánea', en: 'Instant download' },
    efx_chip_updates: { es: 'Actualizaciones de por vida', en: 'Lifetime updates' },
    efx_pillars_eyebrow: { es: 'Lo esencial para elevar tu edit', en: 'The essentials to elevate your edit' },
    efx_pillars_title: { es: '3 pilares. Un solo pack.', en: '3 pillars. One single pack.' },
    efx_pillar_shakes_badge: { es: 'SHAKES', en: 'SHAKES' },
    efx_pillar_shakes_hook: { es: 'Movimiento cinematográfico para cortes con energía.', en: 'Cinematic motion for cuts with energy.' },
    efx_pillar_vfx_badge: { es: 'VFX PACK', en: 'VFX PACK' },
    efx_pillar_vfx_hook: { es: 'Impacto visual nativo en tu timeline.', en: 'Native visual impact in your timeline.' },
    efx_pillar_3d_badge: { es: '3D TITLE', en: '3D TITLE' },
    efx_pillar_3d_hook: { es: 'Texto 3D editable listo para usar.', en: 'Editable 3D text ready to use.' },
    efx_strip_shakes_title: { es: 'Shakes', en: 'Shakes' },
    efx_strip_shakes_text: { es: 'Golpes de cámara y movimiento con intención para transiciones que se sienten reales.', en: 'Camera hits and intentional motion for transitions that feel real.' },
    efx_strip_vfx_title: { es: 'VFX Pack', en: 'VFX Pack' },
    efx_strip_vfx_text: { es: 'Overlays y efectos pensados para sumar impacto visual sin complicar tu flujo.', en: 'Overlays and effects designed to add visual impact without complicating your workflow.' },
    efx_strip_3d_title: { es: '3D Title', en: '3D Title' },
    efx_strip_3d_text: { es: 'Tipografía tridimensional editable para abrir o cerrar piezas con presencia.', en: 'Editable three-dimensional typography to open or close pieces with presence.' },
    efx_guarantee_title: { es: 'Garantía de optimización de flujo por 7 días.', en: '7-day workflow optimization guarantee.' },
    efx_guarantee_text: { es: 'Completamente sujeto a los', en: 'Completely subject to the' },
    efx_cta: { es: 'Quiero el pack esencial', en: 'I want the essential pack' },

    cc_pdp_description: { es: '15 presets de títulos editables para CapCut. Comprá, descargá y usá en PC y Mac. Tutorial incluido.', en: '15 editable title presets for CapCut. Buy, download and use on PC and Mac. Tutorial included.' },
    cc_manifesto_eyebrow: { es: 'Titles Pack · CapCut', en: 'Titles Pack · CapCut' },
    cc_manifesto_title_1: { es: 'El pack más esperado', en: 'The most anticipated pack' },
    cc_manifesto_title_2: { es: 'por editores de CapCut.', en: 'for CapCut editors.' },
    cc_manifesto_lead: { es: 'Los mismos títulos premium que usan miles de editores en Premiere Pro — ahora nativos para tu flujo en CapCut.', en: 'The same premium titles thousands of Premiere Pro editors use — now native to your CapCut workflow.' },
    cc_chip_phone: { es: 'PC y Mac', en: 'PC and Mac' },
    cc_chip_download: { es: 'Descarga instantánea', en: 'Instant download' },
    cc_chip_lifetime: { es: 'Actualizaciones de por vida', en: 'Lifetime updates' },
    cc_origin_eyebrow: { es: 'La historia detrás del pack', en: 'The story behind the pack' },
    cc_origin_title: { es: 'Todos nos pedían lo mismo.', en: 'Everyone asked for the same thing.' },
    cc_origin_sub: { es: '«¿Cuándo sale el pack de títulos de Premiere Pro pero para CapCut?» Lo escuchamos en DMs, comentarios y Discord. Lo construimos.', en: '"When is the Premiere Pro titles pack coming for CapCut?" We heard it in DMs, comments and Discord. So we built it.' },
    cc_origin_pr_label: { es: 'El referente', en: 'The reference' },
    cc_origin_pr_name: { es: 'Pack V1 Titles Premiere Pro', en: 'Pack V1 Titles Premiere Pro' },
    cc_origin_pr_hook: { es: 'La referencia de la industria. Títulos cinematográficos, editables y listos para timeline.', en: 'The industry reference. Cinematic, editable titles ready for your timeline.' },
    cc_origin_pr_link: { es: 'Ver pack Premiere', en: 'View Premiere pack' },
    cc_origin_connector: { es: 'Adaptado para CapCut', en: 'Adapted for CapCut' },
    cc_origin_cc_label: { es: 'Lanzamiento', en: 'Launch' },
    cc_origin_cc_name: { es: 'Titles Pack CapCut', en: 'Titles Pack CapCut' },
    cc_origin_cc_hook: { es: 'La misma energía visual. Presets optimizados para importar, editar y publicar desde CapCut.', en: 'The same visual energy. Presets optimized to import, edit and publish from CapCut.' },
    cc_devices_eyebrow: { es: 'Sin fricción', en: 'Zero friction' },
    cc_devices_title: { es: 'Comprá. Descargá. Editá.', en: 'Buy. Download. Edit.' },
    cc_devices_sub: { es: 'En tu Mac o PC en tu setup. Un solo pack, flujo sin fricción.', en: 'On your Mac or PC at your desk. One pack, zero friction.' },
    cc_compat_label: { es: 'Compatible en CapCut PC y Mac', en: 'Compatible with CapCut on PC and Mac' },
    cc_compat_mac: { es: 'Mac', en: 'Mac' },
    cc_compat_windows: { es: 'Windows', en: 'Windows' },
    cc_wire_title_main: { es: 'TU TÍTULO', en: 'YOUR TITLE' },
    cc_wire_title_sub: { es: 'EDIT', en: 'EDIT' },
    cc_pdp_benefit_1_title: { es: '15 presets', en: '15 presets' },
    cc_pdp_benefit_1_text: { es: 'Listos para importar en CapCut', en: 'Ready to import in CapCut' },
    cc_pdp_benefit_2_title: { es: 'ADN Premiere', en: 'Premiere DNA' },
    cc_pdp_benefit_2_text: { es: 'La misma línea visual que nuestros títulos pro', en: 'The same visual line as our pro titles' },
    cc_pdp_benefit_3_title: { es: 'PC y Mac', en: 'PC and Mac' },
    cc_pdp_benefit_3_text: { es: 'Compatible con CapCut en PC y Mac', en: 'Compatible with CapCut on PC and Mac' },
    cc_pdp_benefit_4_title: { es: 'Para siempre', en: 'Lifetime' },
    cc_pdp_benefit_4_text: { es: 'Actualizaciones incluidas', en: 'Updates included' },
    cc_hero_reviews_line: { es: '3843 reseñas verificadas · 4.9/5 estrellas', en: '3843 verified reviews · 4.9/5 stars' },
    cc_device_mac: { es: 'CapCut en Mac / PC', en: 'CapCut on Mac / PC' },
    cc_flow_buy: { es: 'Comprás', en: 'You buy' },
    cc_flow_buy_sub: { es: 'Pago seguro · acceso al instante', en: 'Secure checkout · instant access' },
    cc_flow_download: { es: 'Descargás', en: 'You download' },
    cc_flow_download_sub: { es: 'Archivos listos en tu cuenta', en: 'Files ready in your account' },
    cc_flow_edit: { es: 'Usás en CapCut', en: 'Use in CapCut' },
    cc_flow_edit_sub: { es: 'Importá presets y editá al toque', en: 'Import presets and edit right away' },
    cc_pillars_eyebrow: { es: 'Dentro del pack', en: 'Inside the pack' },
    cc_pillars_title: { es: 'Títulos que elevan cada corte.', en: 'Titles that elevate every cut.' },
    cc_pillar_1_title: { es: '15 presets editables', en: '15 editable presets' },
    cc_pillar_1_text: { es: 'Personalizá texto, color y timing en segundos.', en: 'Customize text, color and timing in seconds.' },
    cc_pillar_2_title: { es: 'Estética premium', en: 'Premium aesthetic' },
    cc_pillar_2_text: { es: 'Diseñados para reels, TikToks y edits de alto impacto — la misma línea visual que nuestros packs pro.', en: 'Designed for reels, TikToks and high-impact edits — the same visual line as our pro packs.' },
    cc_pillar_3_title: { es: 'Tutorial incluido', en: 'Tutorial included' },
    cc_pillar_3_text: { es: 'Te guiamos paso a paso para importar, aplicar y ajustar cada preset sin perder tiempo.', en: 'We guide you step by step to import, apply and adjust each preset without wasting time.' },
    cc_truth_eyebrow: { es: 'Comunidad CapCut', en: 'CapCut community' },
    cc_truth_title: { es: '3843 reseñas verificadas · 4.9/5 estrellas', en: '3843 verified reviews · 4.9/5 stars' },
    cc_quote_1_text: { es: '"Llevaba meses pidiendo títulos como los de Premiere. Esto es exactamente lo que faltaba en CapCut."', en: '"I had been asking for Premiere-style titles for months. This is exactly what CapCut was missing."' },
    cc_quote_1_author: { es: 'Lucas M. · Editor mobile', en: 'Lucas M. · Mobile editor' },
    cc_quote_2_text: { es: '"Compro en el celu, descargo en el Mac y sigo editando. Flujo impecable."', en: '"I buy on my phone, download on my Mac and keep editing. Seamless workflow."' },
    cc_quote_2_author: { es: 'Camila R. · Creadora TikTok', en: 'Camila R. · TikTok creator' },
    cc_quote_3_text: { es: '"Los presets se ven pro desde el primer frame. Mis reels subieron de nivel al toque."', en: '"The presets look pro from frame one. My reels leveled up instantly."' },
    cc_quote_3_author: { es: 'Tomás G. · Editor freelance', en: 'Tomás G. · Freelance editor' },
    cc_quote_4_text: { es: '"El tutorial de 5 minutos y ya estaba editando. ClashivFX siempre entrega."', en: '"Five-minute tutorial and I was already editing. ClashivFX always delivers."' },
    cc_quote_4_author: { es: 'Sofi L. · Instagram Reels', en: 'Sofi L. · Instagram Reels' },
    cc_quote_5_text: { es: '"Es el pack más esperado del año para CapCut. Sin exagerar."', en: '"The most anticipated CapCut pack of the year. No exaggeration."' },
    cc_quote_5_author: { es: 'Nico P. · Editor YouTube Shorts', en: 'Nico P. · YouTube Shorts editor' },
    cc_quote_6_text: { es: '"Importé un preset en el celu y tenía el reel listo antes de subir al colectivo. Rapidísimo."', en: '"I imported a preset on my phone and had the reel ready before I got on the bus. So fast."' },
    cc_quote_6_author: { es: 'Valentina S. · Creadora UGC', en: 'Valentina S. · UGC creator' },
    cc_quote_7_text: { es: '"Los estilos VHS y gold text son los que más uso en mis clips de gaming."', en: '"VHS and gold text styles are what I use most in my gaming clips."' },
    cc_quote_7_author: { es: 'Mateo F. · Editor gaming', en: 'Mateo F. · Gaming editor' },
    cc_quote_8_text: { es: '"Misma energía visual que los títulos de Premiere, pero directo en CapCut. Justo lo que buscaba."', en: '"Same visual energy as Premiere titles, straight in CapCut. Exactly what I needed."' },
    cc_quote_8_author: { es: 'Juana V. · Productora indie', en: 'Juana V. · Indie producer' },
    cc_quote_9_text: { es: '"En PC se sienten igual de premium. Los 15 presets valen cada peso."', en: '"On PC they feel just as premium. All 15 presets are worth every penny."' },
    cc_quote_9_author: { es: 'Diego A. · Editor CapCut PC', en: 'Diego A. · CapCut PC editor' },
    cc_quote_10_text: { es: '"Mis clientes notaron la diferencia desde el primer delivery. Se ve caro sin esfuerzo."', en: '"My clients noticed the difference from the first delivery. Looks expensive effortlessly."' },
    cc_quote_10_author: { es: 'Emma K. · Editora freelance', en: 'Emma K. · Freelance editor' },
    cc_guarantee_title: { es: 'Garantía de 7 días, si no te sirve te devolvemos tu dinero.', en: '7-day guarantee, if it doesn\'t work for you we\'ll refund your money.' },
    cc_guarantee_text: { es: 'Completamente sujeto a los', en: 'Completely subject to the' },
    cc_cta: { es: 'Quiero el Titles Pack CapCut', en: 'I want the Titles Pack CapCut' },

    nav_full_store: { es: 'Tienda completa', en: 'Full store' },
    header_nav_ultimate_bundle: { es: 'ULTIMATE BUNDLE 2026', en: 'ULTIMATE BUNDLE 2026' },
    header_pack_badge: { es: 'Nuevo', en: 'new' },
    announcement_promo_eyebrow: { es: 'Oferta de lanzamiento', en: 'Launch offer' },
    announcement_promo_discount: { es: '90% OFF', en: '90% OFF' },
    announcement_promo_urgency: { es: 'Por tiempo limitado', en: 'Limited time only' },
    top_discord: { en: 'Discord Community' },
    top_products_heading: { en: 'PROFESSIONAL RESOURCES' },
    top_rating_line1: { en: 'Rated 4.9/5 Excellent' },
    // Actualizado para que el conteo sea consistente al cambiar ES/EN.
    top_rating_line2: { en: '3843 VERIFIED REVIEWS' },
    top_subheading: { en: 'Limited time offers • 2026 Update' },
    community_eyebrow: { en: 'COMMUNITY' },
    community_title: { en: 'Join the community' },
    community_text: { en: 'Over 5,000 active editors are already part of the community.' },
    community_perk: { en: 'Buy any pack and unlock an exclusive rank on Discord' },
    community_btn: { en: 'Join the Discord' },
    vfx_bundle_chip: { en: 'Exclusive for editors' },
    vfx_bundle_badge: { en: 'Limited time offer' },
    vfx_bundle_title: { en: 'Ultimate Bundle Editors Exclusive Pack 2026' },
    vfx_bundle_tagline: { en: 'Very exclusive pack · One limited time offer' },
    vfx_bundle_cta: { es: 'VER BUNDLE', en: 'VIEW BUNDLE' },
    vfx_aio_bundle_chip: { en: 'All-in-one for editors' },
    vfx_aio_bundle_badge: { en: 'Limited time offer' },
    vfx_aio_bundle_title: { en: 'ALL IN ONE BUNDLE' },
    vfx_aio_bundle_desc: { en: 'All-in-one pack for editors with essential resources to speed up your workflow.' },
    vfx_aio_bundle_compare: { en: '$490.00' },
    vfx_aio_bundle_price: { en: '$74.99' },
    vfx_aio_bundle_cta: { en: 'View All In One Bundle' },
    todos_los_productos_title: { en: 'ALL PRODUCTS' },
    footer_copyright: { en: '© 2026 ClashivFX. All rights reserved.' },
    footer_terms: { en: 'Terms and conditions' },
    bundle_heading: { en: 'Build your pack' },
    bundle_catalog: { en: 'Catalog' },
    bundle_pack_label: { en: 'Your Pack' },
    bundle_add_btn: { en: 'Add' },
    bundle_best_seller: { en: 'Best seller' },
    bundle_empty_catalog: { en: 'Select a collection in Customize theme.' },
    bundle_empty_pack: { en: 'Add products from the catalog.' },
    bundle_cta: { en: 'Add Pack to Cart' },
    bundle_cta_microcopy: { en: 'Instant download after payment' },
    bundle_pack_hint: { en: 'Add 2026 Pack or Ultra Workflow and get 60% OFF on the rest.' },
    bundle_subtotal: { en: 'Subtotal' },
    bundle_discount: { en: 'Discount' },
    bundle_total: { en: 'Total' },
    bundle_badge_nuevo: { en: 'New' },
    bundle_badge_mas_usado: { en: 'Most used' },
    rich_community_text: { en: '+5000 people using our resources and in the community' },
    rich_community_btn: { en: 'COMMUNITY' },
    product_add_to_cart: { es: 'Agregar al carrito', en: 'Add to cart' },
    whop_intl_globe_aria: { es: 'Mundo', en: 'World' },
    international_payments_cta: { es: 'PAGOS INTERNACIONALES 🌍💳', en: 'INTERNATIONAL PAYMENTS 🌍💳' },
    product_sold_out: { en: 'Sold out' },
    product_unavailable: { en: 'Unavailable' },
    product_on_sale: { en: 'Sale' },
    badge_mas_vendido: { en: 'BEST SELLER' },
    product_offer_banner: { es: 'OFERTA POR TIEMPO LIMITADO', en: 'LIMITED TIME OFFER' },
    product_countdown_label: { es: 'Oferta de lanzamiento termina en', en: 'Launch offer ends in' },
    product_countdown_note: { es: '90% de descuento por tiempo limitado', en: '90% off for a limited time' },
    product_benefit_1: { es: 'Ahorra horas de trabajo repetitivo', en: 'Save hours of repetitive work' },
    product_benefit_2: { es: 'Look profesional sin necesidad de plugins', en: 'Professional look without plugins' },
    product_benefit_3: { es: 'Usado en producciones de alto nivel', en: 'Used in high-level productions' },
    product_benefit_4: { es: 'Actualizaciones gratuitas para siempre', en: 'Free updates forever' },
    product_note_1: { es: 'Descarga instantánea', en: 'Instant download' },
    product_note_2: { es: 'Actualizaciones de por vida', en: 'Lifetime updates' },
    upsell_add_pack: { en: 'Add Pack to cart' },
    upsell_add_to_cart: { en: 'Add to cart' },
    cart_rec_add: { en: '+ Add' },
    popup_discount_msg: { en: 'Discount is applied in cart when you add the pack.' },
    product_view_full_details: { en: 'View full details' },
    product_quantity_label: { en: 'Quantity' },
    product_sku: { en: 'SKU' },
    product_regular_price: { en: 'Regular price' },
    product_sale_price: { en: 'Sale price' },
    rating_reviews: { en: 'reviews' },
    rating_verified_reviews: { es: 'RESEÑAS VERIFICADAS', en: 'VERIFIED REVIEWS' },
    rating_excellent: { es: 'EXCELENTE', en: 'EXCELLENT' },
    rating_aria_label: { es: 'Valoración 4.9 de 5', en: 'Rating 4.9 out of 5' },
    rating_aria_label_5: { es: 'Valoración 5 de 5', en: 'Rating 5 out of 5' },
    product_countdown_unit_min: { es: 'min', en: 'min' },
    product_countdown_unit_seg: { es: 'seg', en: 'sec' },
    upsell_title: { es: 'Comprando te llevas gratis:', en: 'With this purchase you get it free:' },
    upsell_pack_titulos_copy: { es: 'Si haces esta compra te llevas este gratis.', en: 'If you make this purchase you get this one free.' },
    upsell_pack_titulos_platinum_title: { es: '+500 PLATINUM LUTS PACK', en: '+500 PLATINUM LUTS PACK' },
    upsell_free: { es: 'GRATIS', en: 'FREE' },
    upsell_standard_price: { en: 'Standard price' },
    upsell_most_popular: { en: '★ MOST POPULAR ★' },
    cart_rec_heading: { en: 'Works well with:' },
    popup_title: { en: '🔥 BUILD YOUR OWN PACK AND SAVE' },
    popup_subtext: { en: 'Add 2026 Pack or Ultra Workflow and the rest get 60% OFF.' },
    popup_rule1: { en: 'Add 2026 Ultimate Editing Pack or Ultra Workflow first.' },
    popup_rule2: { en: 'Every product you add after will get 60% OFF.' },
    popup_cta: { en: '🟢 START BUILDING MY PACK' },
    popup_understood: { en: 'Got it' },
    product_trust_line1: { es: '1432 editores compraron este mes', en: '1432 editors bought this month' },
    product_trust_line1_vfx: { es: '478 editores compraron este mes', en: '478 editors bought this month' },
    product_trust_line2: {
      es: 'Garantía de 7 días, si no te sirve, te devolvemos el dinero.',
      en: '7-day guarantee, if it doesn\'t work for you, we\'ll refund you.'
    },
    product_trust_terms: { es: 'Términos y condiciones', en: 'Terms and conditions' },
    terms_page_title: { es: 'Términos y condiciones', en: 'Terms and conditions' },
    terms_content: {
      en: '<h2>WARRANTY AND REFUND POLICY: DIGITAL RESOURCES PACK</h2>' +
        '<h3>1. Nature of the Product and Acceptance</h3>' +
        '<p>By purchasing our Digital Resources Pack (hereinafter, "the Product"), the User acknowledges and accepts that they are acquiring digital content goods that are not supplied on a physical medium. Due to the immediate and irreversible nature of downloading these files, access to the download link or receipt of access keys constitutes final delivery of the product, making physical return impossible.</p>' +
        '<h3>2. Technical Performance Warranty (7 Days)</h3>' +
        '<p>The brand offers a 7-day Technical Satisfaction Warranty from the date of purchase. This warranty is not a free right of withdrawal due to regret, but a functionality warranty.</p>' +
        '<p>A full refund will only be processed under the following strict conditions:</p>' +
        '<ul>' +
        '<li><strong>Demonstrable Critical Errors:</strong> The User must demonstrate that the files have read errors, data corruption or serious technical failures that prevent their use in the compatible software specified in the product description.</li>' +
        '<li><strong>Technical Unusability:</strong> The failure must be inherent to the file and not due to user inexperience, lack of adequate software or insufficient hardware.</li>' +
        '<li><strong>Prior Support Process:</strong> Before requesting a refund, the User must contact our support team to try to resolve the issue. If the error can be fixed by sending a new functional file, the refund request will be invalidated.</li>' +
        '</ul>' +
        '<h3>3. Burden of Proof</h3>' +
        '<p>To make the warranty effective, the User must attach to their claim:</p>' +
        '<ul>' +
        '<li>Screenshots or screen recording (video) showing the technical error or software "crash" when attempting to use the resource.</li>' +
        '<li>Technical specifications of the equipment and version of the software used.</li>' +
        '<li>Sworn statement that, after the refund, they will permanently delete any copy of the downloaded material.</li>' +
        '</ul>' +
        '<h3>4. Exclusion of Refunds for Duplicate Content</h3>' +
        '<p>The Digital Resources Pack is marketed exclusively as an indivisible, closed unit at a single global price. By making the purchase, the User accepts and acknowledges that:</p>' +
        '<ul>' +
        '<li><strong>Indivisibility of the Product:</strong> The pack is purchased as the complete set of tools. There is no possibility of breaking down the price or requesting proportional refunds for individual components.</li>' +
        '<li><strong>Prior Ownership:</strong> Under no circumstances will refunds, whether total or partial, be processed on the grounds that the User already owned one or more of the resources included in the pack (whether from previous individual purchases or obtained from other sources).</li>' +
        '<li><strong>Waiver of Compensation:</strong> The final price is not proratable and is not subject to retroactive discounts. The existence of duplicate files in the User\'s personal library does not constitute a technical failure or a valid reason for dissatisfaction under this policy.</li>' +
        '</ul>' +
        '<h3>5. Refund Exclusions</h3>' +
        '<p>No refunds, whether total or partial, will be made under the following circumstances:</p>' +
        '<ul>' +
        '<li><strong>Subjectivity:</strong> "I don\'t like the style", "It\'s not what I expected" or "I don\'t know how to use it".</li>' +
        '<li><strong>Unchecked Incompatibility:</strong> If the user did not read the software requirements before purchase.</li>' +
        '<li><strong>Detected Access:</strong> If our monitoring system detects that the pack has been fully downloaded multiple times by the user before the claim.</li>' +
        '<li><strong>Lack of Proof:</strong> If the user refuses to send the technical evidence requested in section 3.</li>' +
        '<li><strong>Pre-existing Material:</strong> Any claim based on pre-existing material is excluded: The User assumes the risk of acquiring content they already own when purchasing a bundled resource pack.</li>' +
        '</ul>' +
        '<h3>6. Fraud and Abuse Prevention</h3>' +
        '<p>We reserve the right to deny refunds to users who present systematic purchase and claim patterns. Any attempt at a bank "chargeback" without having gone through the prior support process will be considered a violation of these terms, resulting in the immediate revocation of any license to use the materials and permanent blocking of access to future updates or brand products.</p>'
    },
    sc_promo_title: { es: 'Ahorra horas de edición.', en: 'Save hours of editing.' },
    sc_promo_sub: { es: 'Edita Podcast o cualquier video en segundos', en: 'Edit podcasts or any video in seconds' },
    sc_promo_second_caption: {
      es: 'Ajusta los silencios milimétricamente acorde a tu video',
      en: 'Adjust silences with millimetric precision to match your video'
    },
    sc_spec_pp_title: { es: 'Premiere Pro', en: 'Premiere Pro' },
    sc_spec_pp_text: {
      es: 'Compatible con Adobe Premiere Pro en todas las versiones.',
      en: 'Compatible with Adobe Premiere Pro on all versions.'
    },
    sc_spec_lang_title: { es: 'Español, inglés e Hindi', en: 'Spanish, English, and Hindi' },
    sc_spec_lang_text: {
      es: 'El plugin está disponible en español, inglés e Hindi: podés usarlo en el idioma que prefieras.',
      en: 'The plugin is available in Spanish, English, and Hindi — use it in the language you prefer.'
    },
    sc_specs_aria: {
      es: 'Silence Cutter — compatibilidad e idiomas',
      en: 'Silence Cutter — compatibility and languages'
    },
    sc_demo_gif_alt: { es: 'Demo de Silence Cutter', en: 'Silence Cutter demo' },
    sc_promo_second_alt: {
      es: 'Silence Cutter — ajuste fino de silencios',
      en: 'Silence Cutter — fine-tune silence cuts'
    },
    product_volume_pricing_note: { en: 'Volume pricing available' },
    product_duties_and_taxes: { en: 'Duties and taxes included.' },
    product_taxes_included: { en: 'Taxes included.' },
    product_duties_included: { en: 'Duties included.' },
    product_shipping_policy: { en: 'Shipping costs are calculated at checkout.' },
    product_inventory_low_stock: { en: 'Low stock' },
    product_inventory_low_stock_prefix: { en: 'Low stock: ' },
    product_inventory_low_stock_suffix: { en: ' left' },
    product_inventory_in_stock: { en: 'In stock' },
    product_inventory_in_stock_suffix: { en: 'in stock' },
    product_inventory_out_of_stock: { en: 'Out of stock' },
    product_inventory_continue_selling: { en: 'In stock' },
    product_quantity_in_cart: { en: 'in cart' },
    product_quantity_decrease: { en: 'Decrease quantity for {{ product }}' },
    product_quantity_increase: { en: 'Increase quantity for {{ product }}' },
    product_volume_pricing_title: { en: 'Volume pricing' },
    product_volume_price_at_each: { en: 'at {{ price }} each' },
    product_volume_price_prefix: { en: 'at ' },
    product_volume_price_at_each_suffix: { en: ' each' },
    product_quantity_multiples_of: { en: 'Increments of {{ quantity }}' },
    product_quantity_minimum_of: { en: 'Minimum {{ quantity }}' },
    product_quantity_maximum_of: { en: 'Maximum {{ quantity }}' },
    product_show_more: { en: 'Show more' },
    product_facets_show_more: { en: 'Show more' },
    quick_order_each: { en: 'each' },
    product_unit_price: { en: 'Unit price' },
    product_unit_price_separator: { en: 'per' },
    product_pickup_unavailable: { en: 'Unavailable for pickup' },
    product_pickup_refresh: { en: 'Refresh' },
    product_countdown_unit_h: { es: 'h', en: 'h' },
    product_countdown_unit_m: { es: 'm', en: 'min' },
    product_countdown_unit_s: { es: 's', en: 'sec' },
    promo_line1_prefix: { es: 'RECURSOS USADOS EN PROYECTOS DE ', en: 'RESOURCES USED IN PROJECTS BY ' },
    promo_line1_suffix: { es: ' Y MUCHOS MÁS.', en: ' AND MANY MORE.' },
    promo_ver: { es: 'Ver →', en: 'See →' },
    promo_compat: { es: 'COMPATIBLE Y TESTEADO EN TODOS LOS PROGRAMAS DE EDICIÓN', en: 'COMPATIBLE AND TESTED IN ALL EDITING PROGRAMS' },
    promo_sub: { es: 'CON ESTO VAS A PODER...', en: 'WITH THIS YOU WILL BE ABLE TO...' },
    promo_title: { es: 'LLEVAR TUS VÍDEOS AL SIGUIENTE NIVEL', en: 'TAKE YOUR VIDEOS TO THE NEXT LEVEL' },
    promo_vfx_title: { es: 'VFX & OVERLAYS PARA IMPACTO TOTAL', en: 'VFX & OVERLAYS FOR TOTAL IMPACT' },
    promo_feature_crt: { es: 'CRT', en: 'CRT' },
    promo_feature_crt_desc: { es: 'Televisores antiguos, líneas de escaneo y estática.', en: 'Vintage TVs, scan lines and static.' },
    promo_feature_filmburns: { es: 'FILM BURNS', en: 'FILM BURNS' },
    promo_feature_filmburns_desc: { es: 'Destellos de luz orgánicos para transiciones vintage.', en: 'Organic light flares for vintage transitions.' },
    promo_feature_fuego: { es: 'FUEGO', en: 'FIRE' },
    promo_feature_fuego_desc: { es: 'Elementos de fuego y explosiones realistas.', en: 'Fire elements and realistic explosions.' },
    promo_feature_humos: { es: 'HUMOS', en: 'SMOKE' },
    promo_feature_humos_desc: { es: 'Elementos de humo y vapor atmosféricos.', en: 'Atmospheric smoke and vapor elements.' },
    promo_feature_money: { es: 'MONEY', en: 'MONEY' },
    promo_feature_money_desc: { es: 'Dinero volando y billetes de cualquier moneda.', en: 'Flying money and bills in any currency.' },
    promo_feature_glitches: { es: 'GLITCHES', en: 'GLITCHES' },
    promo_feature_glitches_desc: { es: 'Distorsiones digitales y errores de señal realistas.', en: 'Digital distortions and realistic signal errors.' },
    promo_feature_overlays: { es: 'OVERLAYS', en: 'OVERLAYS' },
    promo_feature_overlays_desc: { es: 'Estilos y elementos visuales variados.', en: 'Varied visual styles and elements.' },
    promo_feature_more: { es: 'Y MUCHAS MÁS COSAS', en: 'AND MUCH MORE' },
    promo_pack_titulos_title: { es: 'INCLUYE EL PACK TÍTULOS PREMIERE PRO', en: 'INCLUDES THE PREMIERE PRO TITLES PACK' },
    promo_pack_titulos_lead: {
      es: 'El 2026 Ultimate Editing Pack incorpora el pack completo de títulos para Premiere Pro (el mismo que vendemos por separado). Vista previa como en la página de Pack Títulos Premiere Pro:',
      en: 'The 2026 Ultimate Editing Pack includes the full Premiere Pro titles pack (the same one sold separately). Preview as on the Pack Titles Premiere Pro product page:'
    },
    promo_pack_titulos_link: { es: 'Ver Pack Títulos Premiere Pro →', en: 'See Pack Titles Premiere Pro →' },
    promo_lut_title: { es: 'POSTPRODUCCIÓN DE NIVEL CINE (LUTS)', en: 'CINEMA-LEVEL COLOR GRADING (LUTs)' },
    promo_sin_color: { es: 'Sin color', en: 'No color' },
    promo_con_color: { es: 'Con color', en: 'With color' },
    promo_sfx_highlight: { es: '+5000 EFECTOS DE SONIDO, + 80 CARPETAS', en: '+5000 SOUND EFFECTS, + 80 FOLDERS' },
    promo_sfx_rest: { es: 'CON MILES DE EFECTOS DE SONIDO PROFESIONALES', en: 'WITH THOUSANDS OF PROFESSIONAL SOUND EFFECTS' },
    promo_results_title: { es: 'RESULTADOS CON EL PACK 2026', en: 'RESULTS WITH THE 2026 PACK' },
    pack_v2_ae_switch_aria: {
      es: 'Ver Pack V2 de Titulos para After Effects',
      en: 'View V2 Titles Pack for After Effects'
    },
    pack_v2_ae_switch_eyebrow: {
      es: 'Tambien tenemos version para AE',
      en: 'We also have an AE version'
    },
    pack_v2_ae_switch_title: {
      es: 'Pack V2 Titulos para After Effects',
      en: 'V2 Titles Pack for After Effects'
    },
    pack_v2_ae_switch_text: {
      es: 'Si editas en After Effects, entra aqui y mira la version optimizada para tu flujo.',
      en: 'If you edit in After Effects, check this version optimized for your workflow.'
    },
    pack_v2_ae_switch_cta: {
      es: 'Ver pack para After Effects ->',
      en: 'View pack for After Effects ->'
    },
    pack_v2_pr_switch_aria: {
      es: 'Ver Pack V2 de Titulos para Premiere Pro',
      en: 'View V2 Titles Pack for Premiere Pro'
    },
    pack_v2_pr_switch_eyebrow: {
      es: 'Tambien tenemos version para Premiere Pro',
      en: 'We also have a Premiere Pro version'
    },
    pack_v2_pr_switch_title: {
      es: 'Pack V2 Titulos para Premiere Pro',
      en: 'V2 Titles Pack for Premiere Pro'
    },
    pack_v2_pr_switch_text: {
      es: 'Si editas en Premiere Pro, entra aqui y mira la version optimizada para tu flujo.',
      en: 'If you edit in Premiere Pro, check this version optimized for your workflow.'
    },
    pack_v2_pr_switch_cta: {
      es: 'Ver pack para Premiere Pro ->',
      en: 'View pack for Premiere Pro ->'
    },

    /* ──────── Pack V2 Títulos Premiere · Showcase estético (PTV2) ──────── */
    ptv2_eyebrow: {
      es: 'Pack V2 · Títulos para Premiere Pro',
      en: 'Pack V2 · Titles for Premiere Pro'
    },
    ptv2_title_1: {
      es: 'No son títulos genéricos.',
      en: 'These aren’t generic titles.'
    },
    ptv2_title_2: {
      es: 'Son tu firma en movimiento.',
      en: 'They’re your signature in motion.'
    },
    ptv2_lead: {
      es: 'Una colección de títulos y textos cinematográficos, 100% editables y listos para arrastrar a tu timeline. Sin plugins, sin After Effects: solo Premiere Pro.',
      en: 'A collection of cinematic titles and texts, 100% editable and ready to drag onto your timeline. No plugins, no After Effects: just Premiere Pro.'
    },
    ptv2_chip_1: { es: '100% editables', en: '100% editable' },
    ptv2_chip_2: { es: 'Sin plugins', en: 'No plugins' },
    ptv2_chip_3: { es: 'Premiere Pro nativo', en: 'Native Premiere Pro' },
    ptv2_feat_1_title: { es: 'Texto 100% editable', en: '100% editable text' },
    ptv2_feat_1_desc: {
      es: 'Cambiá texto, tipografía, color y tamaño en segundos. Control total, cero límites.',
      en: 'Change text, font, color and size in seconds. Full control, zero limits.'
    },
    ptv2_feat_2_title: { es: 'Arrastrá y listo', en: 'Drag & drop' },
    ptv2_feat_2_desc: {
      es: 'Llevá el título a tu timeline y funciona. Sin After Effects, sin plugins, sin complicaciones.',
      en: 'Drop the title on your timeline and it works. No After Effects, no plugins, no hassle.'
    },
    ptv2_feat_3_title: { es: 'Animaciones premium', en: 'Premium animations' },
    ptv2_feat_3_desc: {
      es: 'Entradas y salidas con movimiento profesional que hacen ver cada corte más caro.',
      en: 'Pro-grade in and out motion that makes every cut look more expensive.'
    },
    ptv2_feat_4_title: { es: 'Cualquier idioma', en: 'Any language' },
    ptv2_feat_4_desc: {
      es: 'Compatible con todos los idiomas, incluido árabe. Tus títulos, en tu lengua.',
      en: 'Works with every language, Arabic included. Your titles, in your language.'
    },
    ptv2_voices_eyebrow: { es: 'La prueba real', en: 'Real proof' },
    ptv2_voices_title: {
      es: 'Editores que ya editan con el Pack V2',
      en: 'Editors already cutting with Pack V2'
    },
    ptv2_quote_1_text: {
      es: '“Le da un nivel cine a mis videos en dos clics. Ya no abro After Effects para un título.”',
      en: '“It gives my videos a cinema level in two clicks. I no longer open After Effects for a title.”'
    },
    ptv2_quote_1_author: { es: 'Mateo R. · Editor freelance', en: 'Mateo R. · Freelance editor' },
    ptv2_quote_2_text: {
      es: '“Arrastrás, cambiás el texto y ya está. Es ridículo lo rápido que es.”',
      en: '“You drag it, change the text and that’s it. It’s ridiculous how fast it is.”'
    },
    ptv2_quote_2_author: { es: 'Lucía F. · Editora de contenido', en: 'Lucía F. · Content editor' },
    ptv2_quote_3_text: {
      es: '“Mis entregas se ven más caras y tardo la mitad. Mis clientes lo notaron.”',
      en: '“My deliverables look more expensive and take half the time. My clients noticed.”'
    },
    ptv2_quote_3_author: { es: 'Tomás G. · Editor de marcas', en: 'Tomás G. · Brand editor' },
    ptv2_quote_4_text: {
      es: '“Los títulos animados son lo mejor que probé para Premiere. Punto.”',
      en: '“These animated titles are the best I’ve tried for Premiere. Period.”'
    },
    ptv2_quote_4_author: { es: 'Cami D. · Editora YouTube', en: 'Cami D. · YouTube editor' },
    ptv2_quote_5_text: {
      es: '“Lo uso en todos mis reels. Se nota la diferencia al toque.”',
      en: '“I use it on every reel. You can tell the difference right away.”'
    },
    ptv2_quote_5_author: { es: 'Bruno P. · Reels para artistas', en: 'Bruno P. · Reels for artists' },
    ptv2_cta: { es: 'Quiero el Pack V2', en: 'I want Pack V2' },

    /* ──────── Pack V2 Títulos After Effects · Showcase estético (PTV2AE) ──────── */
    ptv2ae_eyebrow: {
      es: 'Pack V2 · Títulos para After Effects',
      en: 'Pack V2 · Titles for After Effects'
    },
    ptv2ae_title_1: {
      es: 'No son títulos genéricos.',
      en: 'These aren’t generic titles.'
    },
    ptv2ae_title_2: {
      es: 'Son tu firma en movimiento.',
      en: 'They’re your signature in motion.'
    },
    ptv2ae_lead: {
      es: 'Una colección de títulos y textos cinematográficos, 100% editables y con animaciones nativas, optimizados para tu composición en After Effects.',
      en: 'A collection of cinematic titles and texts, 100% editable with native animations, optimized for your After Effects composition.'
    },
    ptv2ae_chip_1: { es: '100% editables', en: '100% editable' },
    ptv2ae_chip_2: { es: 'Animaciones nativas', en: 'Native animations' },
    ptv2ae_chip_3: { es: 'After Effects nativo', en: 'Native After Effects' },
    ptv2ae_feat_1_title: { es: 'Texto 100% editable', en: '100% editable text' },
    ptv2ae_feat_1_desc: {
      es: 'Cambiá texto, tipografía, color y tamaño desde los controles. Control total, cero límites.',
      en: 'Change text, font, color and size from the controls. Full control, zero limits.'
    },
    ptv2ae_feat_2_title: { es: 'Animaciones nativas', en: 'Native animations' },
    ptv2ae_feat_2_desc: {
      es: 'Composiciones listas con keyframes profesionales. Importás, ajustás y renderizás.',
      en: 'Ready-made comps with pro keyframes. Import, tweak and render.'
    },
    ptv2ae_feat_3_title: { es: 'Movimiento premium', en: 'Premium motion' },
    ptv2ae_feat_3_desc: {
      es: 'Entradas y salidas con timing cinematográfico que hacen ver cada escena más cara.',
      en: 'Ins and outs with cinematic timing that make every scene look more expensive.'
    },
    ptv2ae_feat_4_title: { es: 'Cualquier idioma', en: 'Any language' },
    ptv2ae_feat_4_desc: {
      es: 'Compatible con todos los idiomas, incluido árabe. Tus títulos, en tu lengua.',
      en: 'Works with every language, Arabic included. Your titles, in your language.'
    },
    ptv2ae_voices_eyebrow: { es: 'La prueba real', en: 'Real proof' },
    ptv2ae_voices_title: {
      es: 'Editores que ya animan con el Pack V2',
      en: 'Editors already animating with Pack V2'
    },
    ptv2ae_quote_1_text: {
      es: '“Composiciones listas para usar. Le da un nivel cine a mis videos sin construir nada desde cero.”',
      en: '“Ready-to-use comps. It gives my videos a cinema level without building anything from scratch.”'
    },
    ptv2ae_quote_1_author: { es: 'Mateo R. · Motion designer', en: 'Mateo R. · Motion designer' },
    ptv2ae_quote_2_text: {
      es: '“Importás, cambiás el texto y renderizás. Es ridículo lo rápido que es.”',
      en: '“You import it, change the text and render. It’s ridiculous how fast it is.”'
    },
    ptv2ae_quote_2_author: { es: 'Lucía F. · Editora de contenido', en: 'Lucía F. · Content editor' },
    ptv2ae_quote_3_text: {
      es: '“Mis entregas se ven más caras y tardo la mitad. Mis clientes lo notaron.”',
      en: '“My deliverables look more expensive and take half the time. My clients noticed.”'
    },
    ptv2ae_quote_3_author: { es: 'Tomás G. · Editor de marcas', en: 'Tomás G. · Brand editor' },
    ptv2ae_quote_4_text: {
      es: '“Los títulos animados son lo mejor que probé para After Effects. Punto.”',
      en: '“These animated titles are the best I’ve tried for After Effects. Period.”'
    },
    ptv2ae_quote_4_author: { es: 'Cami D. · Editora YouTube', en: 'Cami D. · YouTube editor' },
    ptv2ae_quote_5_text: {
      es: '“Lo uso en todos mis proyectos. Se nota la diferencia al toque.”',
      en: '“I use it on every project. You can tell the difference right away.”'
    },
    ptv2ae_quote_5_author: { es: 'Bruno P. · Reels para artistas', en: 'Bruno P. · Reels for artists' },
    ptv2ae_cta: { es: 'Quiero el Pack V2', en: 'I want Pack V2' },

    /* ──────── Pack Títulos DaVinci Resolve · Showcase estético (PTV2DV) ──────── */
    ptv2dv_eyebrow: {
      es: 'Pack · Títulos para DaVinci Resolve',
      en: 'Pack · Titles for DaVinci Resolve'
    },
    ptv2dv_title_1: {
      es: 'No son títulos genéricos.',
      en: 'These aren’t generic titles.'
    },
    ptv2dv_title_2: {
      es: 'Son tu firma en movimiento.',
      en: 'They’re your signature in motion.'
    },
    ptv2dv_lead: {
      es: 'Una colección de títulos y textos cinematográficos, 100% editables y listos para tu línea de tiempo en DaVinci Resolve. Compatibles con Edit y Fusion.',
      en: 'A collection of cinematic titles and texts, 100% editable and ready for your DaVinci Resolve timeline. Compatible with Edit and Fusion.'
    },
    ptv2dv_chip_1: { es: '100% editables', en: '100% editable' },
    ptv2dv_chip_2: { es: 'Edit y Fusion', en: 'Edit & Fusion' },
    ptv2dv_chip_3: { es: 'DaVinci Resolve nativo', en: 'Native DaVinci Resolve' },
    ptv2dv_feat_1_title: { es: 'Texto 100% editable', en: '100% editable text' },
    ptv2dv_feat_1_desc: {
      es: 'Cambiá texto, tipografía, color y tamaño en segundos. Control total, cero límites.',
      en: 'Change text, font, color and size in seconds. Full control, zero limits.'
    },
    ptv2dv_feat_2_title: { es: 'Listos para tu timeline', en: 'Ready for your timeline' },
    ptv2dv_feat_2_desc: {
      es: 'Arrastrá a tu línea de tiempo y editá. Sin construir nada desde cero.',
      en: 'Drag onto your timeline and edit. No building anything from scratch.'
    },
    ptv2dv_feat_3_title: { es: 'Animaciones premium', en: 'Premium animations' },
    ptv2dv_feat_3_desc: {
      es: 'Entradas y salidas con movimiento profesional que hacen ver cada corte más caro.',
      en: 'Pro-grade in and out motion that makes every cut look more expensive.'
    },
    ptv2dv_feat_4_title: { es: 'Cualquier idioma', en: 'Any language' },
    ptv2dv_feat_4_desc: {
      es: 'Compatible con todos los idiomas, incluido árabe. Tus títulos, en tu lengua.',
      en: 'Works with every language, Arabic included. Your titles, in your language.'
    },
    ptv2dv_voices_eyebrow: { es: 'La prueba real', en: 'Real proof' },
    ptv2dv_voices_title: {
      es: 'Editores que ya editan con el pack en DaVinci',
      en: 'Editors already cutting with the pack in DaVinci'
    },
    ptv2dv_quote_1_text: {
      es: '“Le da un nivel cine a mis videos sin salir de DaVinci. Otra liga.”',
      en: '“It gives my videos a cinema level without leaving DaVinci. Another league.”'
    },
    ptv2dv_quote_1_author: { es: 'Mateo R. · Editor freelance', en: 'Mateo R. · Freelance editor' },
    ptv2dv_quote_2_text: {
      es: '“Arrastrás, cambiás el texto y ya está. Es ridículo lo rápido que es.”',
      en: '“You drag it, change the text and that’s it. It’s ridiculous how fast it is.”'
    },
    ptv2dv_quote_2_author: { es: 'Lucía F. · Editora de contenido', en: 'Lucía F. · Content editor' },
    ptv2dv_quote_3_text: {
      es: '“Mis entregas se ven más caras y tardo la mitad. Mis clientes lo notaron.”',
      en: '“My deliverables look more expensive and take half the time. My clients noticed.”'
    },
    ptv2dv_quote_3_author: { es: 'Tomás G. · Editor de marcas', en: 'Tomás G. · Brand editor' },
    ptv2dv_quote_4_text: {
      es: '“Los mejores títulos que probé para DaVinci Resolve. Punto.”',
      en: '“The best titles I’ve tried for DaVinci Resolve. Period.”'
    },
    ptv2dv_quote_4_author: { es: 'Cami D. · Editora YouTube', en: 'Cami D. · YouTube editor' },
    ptv2dv_quote_5_text: {
      es: '“Lo uso en todos mis proyectos. Se nota la diferencia al toque.”',
      en: '“I use it on every project. You can tell the difference right away.”'
    },
    ptv2dv_quote_5_author: { es: 'Bruno P. · Reels para artistas', en: 'Bruno P. · Reels for artists' },
    ptv2dv_cta: { es: 'Quiero el pack', en: 'I want the pack' },


    /* ──────── Plugins · Showcases estéticos (uwx / scx / lgx) ──────── */
    /* UltraWorkflow showcase (uwx) */
    uwx_card_title: { es: 'PLUGIN ULTRAWORKFLOW', en: 'ULTRAWORKFLOW PLUGIN' },
    uwx_eyebrow: { es: "Plugin · After Effects", en: "Plugin · After Effects" },
    uwx_title_1: { es: "Tu After Effects", en: "Your After Effects" },
    uwx_title_2: { es: "rápido otra vez", en: "fast again" },
    uwx_lead: { es: "Optimizá After Effects con un clic —caché, memoria y rendimiento— y sumá +30 efectos listos, curvas de movimiento y un buscador integrado. Todo tu flujo, más rápido.", en: "Optimize After Effects in one click —cache, memory and performance— plus +30 ready effects, motion curves and a built-in finder. Your whole workflow, faster." },
    uwx_chip_1: { es: "1 clic", en: "1 click" },
    uwx_chip_2: { es: "+30 efectos", en: "+30 effects" },
    uwx_chip_3: { es: "After Effects nativo", en: "Native After Effects" },
    uwx_feat_1_title: { es: "Optimización 1 clic", en: "One-click optimization" },
    uwx_feat_1_desc: { es: "Caché, memoria y rendimiento de After Effects, optimizados con un solo clic.", en: "After Effects cache, memory and performance, optimized in a single click." },
    uwx_feat_2_title: { es: "Rendimiento en vivo", en: "Live performance" },
    uwx_feat_2_desc: { es: "Un sistema en tiempo real detecta las capas pesadas que frenan tu proyecto.", en: "A real-time system detects the heavy layers slowing your project down." },
    uwx_feat_3_title: { es: "Curvas de movimiento", en: "Motion curves" },
    uwx_feat_3_desc: { es: "Curvas avanzadas con controles deslizantes y presets de animación instantáneos.", en: "Advanced curves with sliders and instant animation presets." },
    uwx_feat_4_title: { es: "Biblioteca de presets", en: "Preset library" },
    uwx_feat_4_desc: { es: "Guardá, aplicá y renombrá tus ajustes preestablecidos editables, siempre a mano.", en: "Save, apply and rename your editable presets, always within reach." },
    uwx_feat_5_title: { es: "Buscador integrado", en: "Built-in finder" },
    uwx_feat_5_desc: { es: "Encontrá cualquier recurso sin salir de After Effects.", en: "Find any asset without leaving After Effects." },
    uwx_feat_6_title: { es: "UI premium", en: "Premium UI" },
    uwx_feat_6_desc: { es: "Interfaz fluida y futurista, pensada para que trabajes rápido.", en: "A fluid, futuristic interface built to keep you fast." },
    uwx_voices_eyebrow: { es: "La prueba real", en: "Real proof" },
    uwx_voices_title: { es: "Editores que recuperaron su tiempo", en: "Editors who got their time back" },
    uwx_quote_1_text: { es: "“Tenía AE tildándose cada media hora. Un clic y volvió a fluir. No vuelvo a editar sin esto.”", en: "“AE froze every half hour. One click and it flowed again. I won’t edit without this anymore.”" },
    uwx_quote_1_author: { es: "Nico M. · Motion designer", en: "Nico M. · Motion designer" },
    uwx_quote_2_text: { es: "“Proyectos 4K que antes arrastraban ahora previsualizan fluido. Me ahorra como una hora por jornada.”", en: "“4K projects that used to drag now preview smoothly. It saves me about an hour a day.”" },
    uwx_quote_2_author: { es: "Caro Giménez · Editora freelance", en: "Caro Giménez · Freelance editor" },
    uwx_quote_3_text: { es: "“Lo que más me sorprendió es lo simple: un botón y la RAM se libera sola. Cero configuración.”", en: "“What surprised me most is how simple it is: one button and the RAM frees itself. Zero setup.”" },
    uwx_quote_3_author: { es: "Diego R. · Animador 2D", en: "Diego R. · 2D animator" },
    uwx_quote_4_text: { es: "“Dejé de perder tomas por cierres inesperados. AE aguanta toda la sesión sin colgarse.”", en: "“I stopped losing work to unexpected crashes. AE holds the whole session without freezing.”" },
    uwx_quote_4_author: { es: "Flor Acosta · Editora de YouTube", en: "Flor Acosta · YouTube editor" },
    uwx_quote_5_text: { es: "“El render salía a media máquina. Después de usarlo, las colas terminan bastante más rápido. Vale cada centavo.”", en: "“Renders ran at half speed. After using it, queues finish noticeably faster. Worth every cent.”" },
    uwx_quote_5_author: { es: "Martín Vega · Motion designer", en: "Martín Vega · Motion designer" },
    uwx_cta: { es: "Quiero AE más rápido", en: "I want a faster AE" },
    uwx_card_desc: { es: "Optimizá y acelerá tu flujo en After Effects. Mirá todo lo que incluye más abajo.", en: "Optimize and speed up your After Effects workflow. See everything included below." },
    scx_eyebrow: { es: "Plugin · Premiere Pro", en: "Plugin · Premiere Pro" },
    scx_title_1: { es: "Editá tu podcast", en: "Edit your podcast" },
    scx_title_2: { es: "en segundos, no en horas", en: "in seconds, not hours" },
    scx_lead: { es: "Silence Cutter detecta y recorta los silencios por vos. Lo que antes te robaba la tarde, ahora pasa en un clic.", en: "Silence Cutter detects and trims your silences for you. What used to eat your afternoon now happens in one click." },
    scx_chip_1: { es: "Detección automática", en: "Automatic detection" },
    scx_chip_2: { es: "Premiere Pro", en: "Premiere Pro" },
    scx_chip_3: { es: "Ajuste milimétrico", en: "Pinpoint control" },
    scx_feat_1_title: { es: "Detección automática", en: "Automatic detection" },
    scx_feat_1_desc: { es: "El plugin escucha tu timeline y encuentra cada silencio solo, sin que toques un corte a mano.", en: "The plugin listens to your timeline and finds every silence on its own, with no manual cuts." },
    scx_feat_2_title: { es: "Edición en segundos", en: "Editing in seconds" },
    scx_feat_2_desc: { es: "Recortá horas de grabación en lo que tardás en servirte un café. Le decís listo y sigue editado.", en: "Trim hours of footage in the time it takes to pour a coffee. Hit go and it is done." },
    scx_feat_3_title: { es: "Ajuste milimétrico", en: "Pinpoint control" },
    scx_feat_3_desc: { es: "Vos decidís cuánto silencio dejar. Afinás el corte al milímetro según el ritmo de cada video.", en: "You decide how much silence stays. Tune the cut to the millimeter for each video’s pace." },
    scx_feat_4_title: { es: "Para todo formato", en: "For every format" },
    scx_feat_4_desc: { es: "Podcasts, entrevistas, vlogs y cursos: cualquier proyecto con voz se edita más rápido y limpio.", en: "Podcasts, interviews, vlogs and courses: any voice project gets cut faster and cleaner." },
    scx_voices_title: { es: "Lo que dicen los editores", en: "What editors are saying" },
    scx_quote_1_text: { es: "“Editaba un podcast de dos horas en toda una tarde. Ahora lo tengo listo antes del almuerzo.”", en: "“A two-hour podcast used to take me a whole afternoon. Now it is ready before lunch.”" },
    scx_quote_1_author: { es: "Lucía F. · Editora de podcast", en: "Lucía F. · Podcast editor" },
    scx_quote_2_text: { es: "“Recortar silencios a mano me mataba. Con Silence Cutter recuperé horas cada semana.”", en: "“Cutting silences by hand was killing me. Silence Cutter gave me back hours every week.”" },
    scx_quote_2_author: { es: "Martín R. · Editor freelance", en: "Martín R. · Freelance editor" },
    scx_quote_3_text: { es: "“Hago tres entrevistas por semana. Lo que antes era un día de trabajo ahora son minutos.”", en: "“I do three interviews a week. What used to be a full day is now minutes.”" },
    scx_quote_3_author: { es: "Carla M. · Productora de contenidos", en: "Carla M. · Content producer" },
    scx_quote_4_text: { es: "“El ajuste fino es lo que me convenció. Dejo el silencio justo y el ritmo queda perfecto.”", en: "“The fine control is what sold me. I keep just the right pause and the pacing stays perfect.”" },
    scx_quote_4_author: { es: "Diego S. · Editor de vlogs", en: "Diego S. · Vlog editor" },
    scx_quote_5_text: { es: "“Grabo cursos largos y los silencios eran un infierno. Hoy publico el doble en la misma semana.”", en: "“I record long courses and the silences were a nightmare. Now I publish twice as much in the same week.”" },
    scx_quote_5_author: { es: "Valentina P. · Creadora de cursos", en: "Valentina P. · Course creator" },
    scx_cta: { es: "Quiero editar en segundos", en: "I want to edit in seconds" },
    scx_voices_eyebrow: { es: "La prueba real", en: "Real proof" },
    sdx_bg_alt: { es: "SFX Deck en movimiento", en: "SFX Deck in motion" },
    sdx_eyebrow: { es: "Diseño de sonido · Premiere Pro", en: "Sound design · Premiere Pro" },
    sdx_title_1: { es: "Tu librería de sonido", en: "Your sound library" },
    sdx_title_2: { es: "a un clic del timeline", en: "one click from the timeline" },
    sdx_lead: { es: "SFX Deck es la herramienta definitiva para diseñar sonido en Premiere Pro. Carga tus propios sonidos e impórtalos al timeline con un solo clic.", en: "SFX Deck is the ultimate tool to design sound in Premiere Pro. Load your own sounds and drop them on the timeline with a single click." },
    sdx_chip_1: { es: "Tus propios sonidos", en: "Your own sounds" },
    sdx_chip_2: { es: "Un clic al timeline", en: "One click to timeline" },
    sdx_chip_3: { es: "Premiere Pro nativo", en: "Native Premiere Pro" },
    sdx_hero_cta: { es: "Quiero SFX Deck", en: "I want SFX Deck" },
    sdx_inc_num: { es: "+5.000", en: "+5,000" },
    sdx_inc_label: { es: "Efectos de sonido incluidos", en: "Sound effects included" },
    sdx_product_shot_alt: { es: "Interfaz de SFX Deck en Premiere Pro", en: "SFX Deck interface in Premiere Pro" },
    sdx_feat_1_title: { es: "Carga tus propios sonidos", en: "Load your own sounds" },
    sdx_feat_1_desc: { es: "Importa tus librerías y SFX favoritos. SFX Deck los organiza por carpetas, listos para usar en cualquier proyecto.", en: "Import your favorite libraries and SFX. SFX Deck organizes them into folders, ready to use in any project." },
    sdx_feat_2_title: { es: "Un solo clic al timeline", en: "One click to the timeline" },
    sdx_feat_2_desc: { es: "Encuentra el sonido perfecto y suéltalo en tu secuencia al instante. Sin arrastrar archivos ni perderte entre carpetas.", en: "Find the perfect sound and drop it into your sequence instantly. No dragging files or getting lost in folders." },
    sdx_feat_3_title: { es: "Todo siempre a mano", en: "Everything at hand" },
    sdx_feat_3_desc: { es: "Favoritos, recientes y frecuentes a la vista. Busca, escucha la onda y colócalo en segundos.", en: "Favorites, recent and frequent always in view. Search, preview the waveform and place it in seconds." },
    sdx_feat_4_title: { es: "Premiere Pro nativo", en: "Native Premiere Pro" },
    sdx_feat_4_desc: { es: "Funciona dentro de Premiere Pro como una extensión más. Tu flujo de sonido, sin salir del editor.", en: "Runs inside Premiere Pro as just another extension. Your sound workflow, without leaving the editor." },
    sdx_cta: { es: "Quiero diseñar sonido más rápido", en: "I want to design sound faster" },
    sdx_g_1: { es: "Pago seguro", en: "Secure checkout" },
    sdx_g_2: { es: "Descarga instantánea", en: "Instant download" },
    sdx_g_3: { es: "Actualizaciones de por vida", en: "Lifetime updates" },
    sdx_buy_cta: { es: "Agregar al carrito", en: "Add to cart" },
    sdx_timer_label: { es: "Oferta termina en", en: "Offer ends in" },
    sdx_price_label: { es: "Precio actual", en: "Current price" },
    sdx_benefits_head: { es: "Incluye con tu compra", en: "Included with your purchase" },
    lgx_eyebrow: { es: "Plugin · After Effects", en: "Plugin · After Effects" },
    lgx_title_1: { es: "El efecto Liquid Glass", en: "The Liquid Glass effect" },
    lgx_title_2: { es: "en un solo clic", en: "in a single click" },
    lgx_lead: { es: "El look glass de Apple que todos quieren, listo al instante. Sin tutoriales, sin keyframes, sin armar nada desde cero.", en: "The Apple-style glass look everyone wants, ready instantly. No tutorials, no keyframes, nothing built from scratch." },
    lgx_chip_1: { es: "1 clic", en: "1 click" },
    lgx_chip_2: { es: "Sin keyframes", en: "No keyframes" },
    lgx_chip_3: { es: "After Effects", en: "After Effects" },
    lgx_feat_1_title: { es: "Efecto al instante", en: "Instant effect" },
    lgx_feat_1_desc: { es: "Aplicás el vidrio líquido en segundos y seguís editando. Cero espera, cero configuración previa, todo automático.", en: "Apply liquid glass in seconds and keep editing. Zero waiting, zero setup, everything automatic." },
    lgx_feat_2_title: { es: "Un solo clic", en: "One single click" },
    lgx_feat_2_desc: { es: "Olvidate de tutoriales eternos y de armar keyframes a mano. Un clic y el efecto ya está hecho.", en: "Forget endless tutorials and building keyframes by hand. One click and the effect is done." },
    lgx_feat_3_title: { es: "Look estilo Apple", en: "Apple-style look" },
    lgx_feat_3_desc: { es: "Ese glassmorphism caro y moderno que ves en las mejores marcas, ahora directo en tu timeline.", en: "That expensive, modern glassmorphism you see in top brands, now right inside your timeline." },
    lgx_feat_4_title: { es: "Listo para todo", en: "Ready for anything" },
    lgx_feat_4_desc: { es: "Personalizable y perfecto para reels, intros, transiciones y mockups de UI con acabado premium.", en: "Customizable and perfect for reels, intros, transitions and UI mockups with a premium finish." },
    lgx_voices_title: { es: "Lo que dicen los editores", en: "What editors are saying" },
    lgx_quote_1_text: { es: "“Lo apliqué en mi primer reel y parecía hecho por un estudio. Un clic y listo, increíble.”", en: "“I used it on my first reel and it looked like studio work. One click and done, unreal.”" },
    lgx_quote_1_author: { es: "Cami D. · Editora de reels", en: "Cami D. · Reels editor" },
    lgx_quote_2_text: { es: "“Tardaba horas imitando el glass de Apple. Ahora lo tengo en segundos y mis clientes lo aman.”", en: "“I spent hours faking the Apple glass. Now I get it in seconds and my clients love it.”" },
    lgx_quote_2_author: { es: "Martín R. · Motion designer", en: "Martín R. · Motion designer" },
    lgx_quote_3_text: { es: "“Sin keyframes, sin vueltas. Lo instalé y a los dos minutos ya estaba exportando con ese look premium.”", en: "“No keyframes, no fuss. I installed it and was exporting that premium look within two minutes.”" },
    lgx_quote_3_author: { es: "Sofi L. · Creadora de contenido", en: "Sofi L. · Content creator" },
    lgx_quote_4_text: { es: "“Por 4.99 me ahorré comprar tutoriales y presets carísimos. La mejor inversión que hice este año.”", en: "“For 4.99 I saved buying pricey tutorials and presets. Best investment I made this year.”" },
    lgx_quote_4_author: { es: "Nico V. · Editor freelance", en: "Nico V. · Freelance editor" },
    lgx_quote_5_text: { es: "“Mis intros ahora parecen de Apple. El cliente aprobó al toque y pidió más videos así.”", en: "“My intros now look like Apple’s. The client approved instantly and asked for more like it.”" },
    lgx_quote_5_author: { es: "Lucía M. · Editora de video", en: "Lucía M. · Video editor" },
    lgx_cta: { es: "Quiero el efecto", en: "I want the effect" },
    lgx_voices_eyebrow: { es: "La prueba real", en: "Real proof" },

    product_more_limited_offers: {
      es: 'MAS OFERTAS LIMITADAS',
      en: 'MORE LIMITED OFFERS'
    },
    product_view_offer: {
      es: 'Ver oferta ->',
      en: 'View offer ->'
    },
    catalog_zone_titles: { es: 'TÍTULOS', en: 'TITLES' },
    catalog_zone_professional_packs: { es: 'PACKS PROFESIONALES', en: 'PROFESSIONAL PACKS' },
    catalog_zone_plugins: { es: 'PLUGINS', en: 'PLUGINS' },
    catalog_zone_editable_projects: { es: 'PROYECTOS EDITABLES', en: 'EDITABLE PROJECTS' },
    catalog_zone_more: { es: 'MÁS', en: 'MORE' },
    upsell_titles_choose_version: { es: 'ELIGE TU VERSIÓN:', en: 'CHOOSE YOUR VERSION:' },
    upsell_titles_choose_version_aria: { es: 'Elegir versión de compra', en: 'Choose purchase version' },
    upsell_titles_recommended_badge: { es: '★ RECOMENDADO ★', en: '★ RECOMMENDED ★' },
    upsell_titles_freebies_prefix: { es: 'Comprando te llevas gratis:', en: 'With this purchase you get it free:' },
    upsell_titles_freebies_sfx: { es: '5000 SFX ULTIMATE PACK', en: '5000 SFX ULTIMATE PACK' },
    upsell_titles_freebies_platinum: { es: '+500 PLATINUM LUTS PACK', en: '+500 PLATINUM LUTS PACK' },
    upsell_titles_view_v1_aria: { es: 'Ver versión V1', en: 'View V1 version' },
    pdp_titles_lang_premiere: {
      es: 'Títulos editables traducibles a todos los idiomas, incluido árabe.',
      en: 'Editable titles translatable to all languages, including Arabic.'
    },
    pdp_titles_lang_ae: {
      es: 'Títulos editables traducibles a todos los idiomas, incluido árabe.',
      en: 'Editable titles translatable to all languages, including Arabic.'
    },
    pdp_titles_lang_davinci: {
      es: 'Títulos editables traducibles a todos los idiomas, incluido árabe.',
      en: 'Editable titles translatable to all languages, including Arabic.'
    },
    pdp_titles_lang_capcut: {
      es: 'Títulos editables traducibles a todos los idiomas, incluido árabe.',
      en: 'Editable titles translatable to all languages, including Arabic.'
    },
    pdp_titles_lang_capcut_title: { es: 'Multilingüe', en: 'Multilingual' },
    pdp_titles_lang_capcut_text: {
      es: 'Todos los idiomas, incl. árabe',
      en: 'All languages, incl. Arabic'
    }
  };

  function getLang() {
    try {
      var stored = localStorage.getItem(STORAGE_KEY);
      return stored === 'en' || stored === 'es' ? stored : DEFAULT_LANG;
    } catch (e) {
      return DEFAULT_LANG;
    }
  }

  function setLang(lang) {
    try {
      localStorage.setItem(STORAGE_KEY, lang);
    } catch (e) {}
    document.documentElement.setAttribute('lang', lang);
    document.documentElement.setAttribute('data-lang', lang);
  }

  /* ── Idioma REAL de Shopify ──────────────────────────────────────────
     El toggle es solo JS y no toca el checkout. Para que el checkout salga
     en el mismo idioma, hay que activar el "locale" real de Shopify:
     español = default (sin prefijo), inglés = subcarpeta /en.
     getShopifyLocale() lee el idioma real; switchShopifyLocale() lo cambia. */
  function getShopifyLocale() {
    try {
      var sl = window.Shopify && window.Shopify.locale;
      if (typeof sl === 'string' && sl) {
        return sl.toLowerCase().indexOf('en') === 0 ? 'en' : 'es';
      }
    } catch (e) {}
    return /^\/en(\/|$)/i.test(window.location.pathname) ? 'en' : 'es';
  }

  // Cambia el idioma REAL de Shopify navegando a la subcarpeta /en (o sacándola
  // para español) y recarga. El checkout hereda el idioma en todos los botones,
  // incluidos los express. La contra: recarga la página al cambiar de idioma.
  function switchShopifyLocale(lang) {
    var path = window.location.pathname.replace(/^\/(en|es)(?=\/|$)/i, '');
    if (!path) path = '/';
    var prefix = lang === 'en' ? '/en' : '';
    window.location.href = prefix + path + window.location.search + window.location.hash;
  }

  function applyIndexPageTitle(lang) {
    var isEn = lang === 'en';
    var body = document.body;
    if (!body || body.getAttribute('data-index-title') !== '1') return;
    var t = I18N.nav_full_store;
    if (!t) return;
    var suf = body.getAttribute('data-title-suffix') || '';
    document.title = (isEn ? t.en : t.es) + suf;
  }

  function applyLang(lang) {
    var isEn = lang === 'en';
    var root = document.body || document.documentElement;
    if (!root) return;

    document.querySelectorAll('[data-i18n]').forEach(function (el) {
      var key = el.getAttribute('data-i18n');
      if (!key || !I18N[key]) return;
      var attrName = el.getAttribute('data-i18n-attr');
      if (attrName) {
        if (isEn) {
          var origAttr = el.getAttribute('data-i18n-es');
          if (origAttr === null || origAttr === undefined) {
            origAttr = el.getAttribute(attrName) || '';
            el.setAttribute('data-i18n-es', origAttr);
          }
          if (savedEs[key] === undefined) savedEs[key] = origAttr;
          el.setAttribute(attrName, I18N[key].en);
        } else {
          var savedAttr = el.getAttribute('data-i18n-es');
          if (savedAttr === null || savedAttr === undefined) savedAttr = savedEs[key];
          var attrToShow = savedAttr;
          if (attrToShow === undefined && I18N[key] && I18N[key].es) attrToShow = I18N[key].es;
          if (attrToShow !== undefined && attrToShow !== null) el.setAttribute(attrName, attrToShow);
        }
        return;
      }
      if (isEn) {
        var orig = el.getAttribute('data-i18n-es');
        if (orig === null || orig === undefined) {
          orig = el.innerHTML && el.innerHTML.trim().indexOf('<') !== -1 ? el.innerHTML : (el.textContent || '');
          el.setAttribute('data-i18n-es', orig);
        }
        if (savedEs[key] === undefined) savedEs[key] = orig;
        el.textContent = I18N[key].en;
        if (key === 'bundle_add_btn' && el.hasAttribute('data-default-text')) {
          el.setAttribute('data-default-text', I18N[key].en);
        }
      } else {
        var saved = el.getAttribute('data-i18n-es');
        if (saved === null || saved === undefined) saved = savedEs[key];
        var textToShow = saved;
        if (textToShow === undefined && I18N[key] && I18N[key].es) textToShow = I18N[key].es;
        if (textToShow !== undefined && textToShow !== null) {
          if (textToShow.indexOf('<') !== -1) {
            el.innerHTML = textToShow;
          } else {
            el.textContent = textToShow;
          }
        }
        if (key === 'bundle_add_btn' && el.hasAttribute('data-default-text')) {
          el.setAttribute('data-default-text', savedEs[key] || 'Agregar');
        }
      }
    });

    document.querySelectorAll('[data-i18n-html]').forEach(function (el) {
      var key = el.getAttribute('data-i18n-html');
      if (!key || !I18N[key]) return;
      if (isEn) {
        var origHtml = el.getAttribute('data-i18n-es');
        if (origHtml === null || origHtml === undefined) {
          origHtml = el.innerHTML || '';
          el.setAttribute('data-i18n-es', origHtml);
        }
        if (savedEs[key] === undefined) savedEs[key] = origHtml;
        if (I18N[key].en) el.innerHTML = I18N[key].en;
      } else {
        var savedHtml = el.getAttribute('data-i18n-es');
        if (savedHtml === null || savedHtml === undefined) savedHtml = savedEs[key];
        if (savedHtml !== undefined && savedHtml !== null) el.innerHTML = savedHtml;
      }
    });

    applyIndexPageTitle(lang);

    if (isEn) {
      root.querySelectorAll('[data-upsell]').forEach(function (upsellRoot) {
        upsellRoot.setAttribute('data-label-pack', I18N.upsell_add_pack.en);
        upsellRoot.setAttribute('data-label-bundle', I18N.upsell_add_to_cart.en);
        var sectionId = upsellRoot.getAttribute('data-section-id');
        var btn = sectionId ? document.getElementById('ProductSubmitButton-' + sectionId) : null;
        if (btn) {
          var labelSpan = btn.querySelector('span:first-child');
          var checked = upsellRoot.querySelector('[data-upsell-radio]:checked');
          var defaultId = upsellRoot.getAttribute('data-default-variant-id');
          var useBundle = checked && checked.value === defaultId;
          if (labelSpan) labelSpan.textContent = useBundle ? I18N.upsell_add_to_cart.en : I18N.upsell_add_pack.en;
        }
      });
    } else {
      root.querySelectorAll('[data-upsell]').forEach(function (upsellRoot) {
        upsellRoot.setAttribute('data-label-pack', 'Agregar Pack al carrito');
        upsellRoot.setAttribute('data-label-bundle', 'Agregar al carrito');
        var sectionId = upsellRoot.getAttribute('data-section-id');
        var btn = sectionId ? document.getElementById('ProductSubmitButton-' + sectionId) : null;
        if (btn) {
          var labelSpan = btn.querySelector('span:first-child');
          var checked = upsellRoot.querySelector('[data-upsell-radio]:checked');
          var defaultId = upsellRoot.getAttribute('data-default-variant-id');
          var useBundle = checked && checked.value === defaultId;
          if (labelSpan) labelSpan.textContent = useBundle ? 'Agregar al carrito' : 'Agregar Pack al carrito';
        }
      });
    }
    applyProductTranslations(isEn ? 'en' : 'es');
    refreshCapcutOfferHighlights();
    try {
      document.documentElement.setAttribute('data-lang', lang);
      document.dispatchEvent(new CustomEvent('clash:langchange', { detail: { lang: lang } }));
    } catch (e) {}
  }

  function loadProductTranslations(cb) {
    if (productTranslationsCache !== null) {
      cb(productTranslationsCache);
      return;
    }
    var xhr = new XMLHttpRequest();
    xhr.open('GET', getProductTranslationsUrl(), true);
    xhr.onload = function () {
      if (xhr.status >= 200 && xhr.status < 400) {
        try {
          productTranslationsCache = JSON.parse(xhr.responseText);
        } catch (e) {
          productTranslationsCache = {};
        }
      } else {
        productTranslationsCache = {};
      }
      cb(productTranslationsCache);
    };
    xhr.onerror = function () {
      productTranslationsCache = {};
      cb(productTranslationsCache);
    };
    xhr.send();
  }

  function applyProductTranslations(lang) {
    var root = document.body || document.documentElement;
    var container = root.querySelector('[data-product-handle]');
    if (!container) return;
    var handle = container.getAttribute('data-product-handle');
    if (!handle) return;
    var isEn = lang === 'en';
    var priceHtml = container.getAttribute('data-i18n-price-html') || '';
    function injectPriceToken(html) {
      if (!html || !priceHtml) return html;
      var price = priceHtml;
      if (handle === 'pack-titles-capcut') {
        price = wrapCapcutPriceGlow(priceHtml);
      }
      return String(html).split('{{PRICE}}').join(price);
    }

    if (isEn) {
      loadProductTranslations(function (allTranslations) {
        var t = allTranslations[handle];
        if (!t) return;
        var textIndex = 0;
        var collapsibleIndex = 0;
        var popupIndex = 0;
        root.querySelectorAll('[data-product-i18n]').forEach(function (el) {
          var key = el.getAttribute('data-product-i18n');
          var storageKey = handle + ':' + key;
          if (key === 'title') {
            storageKey = handle + ':title';
            if (productOriginalContent[storageKey] === undefined) {
              productOriginalContent[storageKey] = el.textContent || '';
            }
            if (t.title) el.textContent = t.title;
            return;
          }
          if (key === 'description') {
            storageKey = handle + ':description';
            if (productOriginalContent[storageKey] === undefined) {
              productOriginalContent[storageKey] = el.innerHTML || '';
            }
            if (t.description) {
              var descHtml = t.description;
              descHtml = injectTodayDateToken(descHtml, 'en', handle);
              descHtml = injectPriceToken(descHtml);
              el.innerHTML = descHtml;
            }
            return;
          }
          if (key === 'text') {
            storageKey = handle + ':text:' + textIndex;
            if (productOriginalContent[storageKey] === undefined) {
              productOriginalContent[storageKey] = el.textContent || '';
            }
            if (t.texts && t.texts[textIndex]) el.textContent = t.texts[textIndex];
            textIndex++;
            return;
          }
          if (key === 'benefit_1' || key === 'benefit_2' || key === 'benefit_3' || key === 'benefit_4') {
            var idx = parseInt(key.replace('benefit_', ''), 10);
            var arr = t.benefits;
            if (productOriginalContent[handle + ':' + key] === undefined) {
              productOriginalContent[handle + ':' + key] = el.textContent || '';
            }
            if (arr && arr[idx - 1]) el.textContent = arr[idx - 1];
            return;
          }
          if (key === 'note_1' || key === 'note_2') {
            var nIdx = parseInt(key.replace('note_', ''), 10);
            var notes = t.notes;
            if (productOriginalContent[handle + ':' + key] === undefined) {
              productOriginalContent[handle + ':' + key] = el.textContent || '';
            }
            if (notes && notes[nIdx - 1]) el.textContent = notes[nIdx - 1];
            return;
          }
          if (key === 'collapsible_heading') {
            var cArr = t.collapsible;
            storageKey = handle + ':collapsible_heading:' + collapsibleIndex;
            if (productOriginalContent[storageKey] === undefined) {
              productOriginalContent[storageKey] = el.textContent || '';
            }
            if (cArr && cArr[collapsibleIndex] && cArr[collapsibleIndex].heading) {
              el.textContent = cArr[collapsibleIndex].heading;
            }
            collapsibleIndex++;
            return;
          }
          if (key === 'collapsible_content') {
            if (collapsibleIndex > 0) {
              var contentIdx = collapsibleIndex - 1;
              storageKey = handle + ':collapsible_content:' + contentIdx;
              if (productOriginalContent[storageKey] === undefined) {
                productOriginalContent[storageKey] = el.innerHTML || '';
              }
              var cArr = t.collapsible;
              if (cArr && cArr[contentIdx] && cArr[contentIdx].content) {
                el.innerHTML = cArr[contentIdx].content;
              }
            }
            return;
          }
          if (key === 'popup_label') {
            storageKey = handle + ':popup_label:' + popupIndex;
            if (productOriginalContent[storageKey] === undefined) {
              productOriginalContent[storageKey] = el.textContent || '';
            }
            if (t.popup_labels && t.popup_labels[popupIndex]) el.textContent = t.popup_labels[popupIndex];
            popupIndex++;
          }
        });
      });
    } else {
      loadProductTranslations(function (allTranslations) {
        var t = allTranslations[handle];
        var textIdx = 0;
        var collapsibleHeadingIdx = 0;
        var collapsibleContentIdx = 0;
        var popupIdx = 0;
        var noteIdx = 0;
        root.querySelectorAll('[data-product-i18n]').forEach(function (el) {
          var key = el.getAttribute('data-product-i18n');
          var saved;
          if (key === 'text') {
            saved = productOriginalContent[handle + ':text:' + textIdx];
            if (saved !== undefined) el.textContent = saved;
            textIdx++;
          } else if (key === 'collapsible_heading') {
            saved = productOriginalContent[handle + ':collapsible_heading:' + collapsibleHeadingIdx];
            if (saved !== undefined) el.textContent = saved;
            collapsibleHeadingIdx++;
          } else if (key === 'collapsible_content') {
            saved = productOriginalContent[handle + ':collapsible_content:' + collapsibleContentIdx];
            if (saved !== undefined) el.innerHTML = saved;
            collapsibleContentIdx++;
          } else if (key === 'popup_label') {
            saved = productOriginalContent[handle + ':popup_label:' + popupIdx];
            if (saved !== undefined) el.textContent = saved;
            popupIdx++;
          } else if (key === 'benefit_1' || key === 'benefit_2' || key === 'benefit_3' || key === 'benefit_4') {
            var idx = parseInt(key.replace('benefit_', ''), 10);
            if (t && t.benefits_es && t.benefits_es[idx - 1]) {
              el.textContent = t.benefits_es[idx - 1];
              productOriginalContent[handle + ':' + key] = t.benefits_es[idx - 1];
            } else {
              saved = productOriginalContent[handle + ':' + key];
              if (saved !== undefined) el.textContent = saved;
            }
          } else if (key === 'note_1' || key === 'note_2') {
            var nIdx = parseInt(key.replace('note_', ''), 10);
            if (t && t.notes_es && t.notes_es[nIdx - 1]) {
              el.textContent = t.notes_es[nIdx - 1];
              productOriginalContent[handle + ':' + key] = t.notes_es[nIdx - 1];
            } else {
              saved = productOriginalContent[handle + ':' + key];
              if (saved !== undefined) el.textContent = saved;
            }
            noteIdx++;
          } else if (key === 'title') {
            saved = productOriginalContent[handle + ':title'];
            if (saved !== undefined) {
              el.textContent = saved;
            } else if (t && t.title_es) {
              el.textContent = t.title_es;
              productOriginalContent[handle + ':title'] = t.title_es;
            }
          } else if (key === 'description') {
            if (t && t.description_es) {
              var descEs = t.description_es;
              descEs = injectTodayDateToken(descEs, 'es', handle);
              descEs = injectPriceToken(descEs);
              el.innerHTML = descEs;
              productOriginalContent[handle + ':description'] = t.description_es;
            } else {
              saved = productOriginalContent[handle + ':description'];
              if (saved !== undefined) {
                saved = injectTodayDateToken(saved, 'es', handle);
                saved = injectPriceToken(saved);
                el.innerHTML = saved;
              }
            }
          } else {
            saved = productOriginalContent[handle + ':' + key];
            if (saved !== undefined) {
              if (key === 'description') el.innerHTML = saved;
              else el.textContent = saved;
            }
          }
        });
      });
    }
  }

  function updateSwitcherUI(current) {
    var wrap = document.getElementById('lang-switcher');
    if (!wrap) return;
    wrap.querySelectorAll('[data-lang-set]').forEach(function (btn) {
      var btnLang = btn.getAttribute('data-lang-set');
      btn.classList.toggle('is-active', btnLang === current);
      btn.setAttribute('aria-pressed', btnLang === current ? 'true' : 'false');
    });
  }

  function createSwitcher() {
    // El idioma REAL de Shopify (URL /en o default) manda: así lo que ve el
    // cliente y lo que verá en el checkout siempre coinciden.
    var current = getShopifyLocale();
    setLang(current);
    applyLang(current);
    updateSwitcherUI(current);

    document.addEventListener('click', function (e) {
      var target = e.target;
      var btn = null;
      while (target && target !== document.body) {
        if (target.getAttribute && target.getAttribute('data-lang-set')) {
          btn = target;
          break;
        }
        target = target.parentNode;
      }
      if (!btn) return;
      var lang = btn.getAttribute('data-lang-set');
      if (lang !== 'es' && lang !== 'en') return;
      if (lang === current) return;
      setLang(lang);
      updateSwitcherUI(lang);
      // Cambia el idioma REAL de Shopify y recarga: el checkout hereda el idioma.
      switchShopifyLocale(lang);
    });

    document.addEventListener('shopify:section:load', function () {
      applyLang(getLang());
      if (typeof window.clashivfxReapplyWhopFbclid === 'function') {
        window.clashivfxReapplyWhopFbclid();
      }
    });
  }

  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', createSwitcher);
    } else {
      createSwitcher();
    }
  }

  init();

  /* Volver atrás (bfcache): reaplicar textos y título de inicio */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    var lang = getShopifyLocale();
    setLang(lang);
    applyLang(lang);
    updateSwitcherUI(lang);
  });
})();
